import type { TreeFile, TreeFolder } from './projectService'
import { fileUid } from './projectService'
import backendFallbackSource from '../assets/fallback/Hello World.java?raw'

export const BACKEND_FALLBACK_TIMEOUT_MS = 10_00

const BACKEND_FALLBACK_FILE_NAME = 'Hello World.java'
const BACKEND_FALLBACK_PROJECT_ID = 'backend-fallback'
const BACKEND_FALLBACK_NAMESPACE_ID = 'Test Projekt'

export function buildBackendFallbackTree(): {
  root: TreeFolder
  contents: Record<string, string>
} {
  const files: TreeFile[] = [
    {
      path: BACKEND_FALLBACK_FILE_NAME,
      name: BACKEND_FALLBACK_FILE_NAME,
    },
  ]

  return {
    root: {
      id: BACKEND_FALLBACK_NAMESPACE_ID,
      name: 'Backend gerade nicht ereichbar',
      folders: [
        {
          id: BACKEND_FALLBACK_PROJECT_ID,
          name: 'Testprojekt',
          folders: [],
          files,
        },
      ],
      files: [],
    },
    contents: {
      [fileUid(BACKEND_FALLBACK_PROJECT_ID, BACKEND_FALLBACK_FILE_NAME)]: backendFallbackSource,
    },
  }
}
